import React from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";

class urlFieldForm extends React.Component {

    render() {
        if (this.props.presets.option_id) {
            return (
                <div className="col-md-10">
                    <div className="row form-row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <Select
                                    {...this.props.getFieldProps("priority")}
                                    objectValue={false}
                                    name="priority"
                                    optionname="priority_value"
                                    storeType="local"
                                    value={this.props.values.priority || 0}
                                    saveChanges={this.props.setFieldValue}
                                    label="Kiemelés"
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <DateTimeInput
                                    {...this.props.getFieldProps("start_date")}
                                    isClearable={true}
                                    maxDate={this.props.values.end_date}
                                    name="start_date"
                                    value={this.props.values.start_date}
                                    label="Kezdés"
                                    showTime={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <DateTimeInput
                                    {...this.props.getFieldProps("end_date")}
                                    isClearable={true}
                                    minDate={this.props.values.start_date}
                                    name="end_date"
                                    value={this.props.values.end_date}
                                    label="Lejárat"
                                    showTime={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="col-md-10">
                <div className="form-group">
                    <label className="control-label">Kiemelés</label>
                    <div className="form-control">Kérlek mentsd el az kiemelés létrehozásához!</div>
                </div>
            </div>
        );
    }
}

export default createForm(urlFieldForm);
